import { getOptionValue } from "./options";
export const getControlValues = (data) => {
  const details = {};

  data.forEach((row, rowIndex) => {
    row.cellData.forEach((cell, cellIndex) => {
      if (cell.type === "control") {
        details[cell.data.code] = getOptionValue(cell.data);
      }
    });
  });

  return details;
};
